<template>
    
    <div v-if="data.linkclass" 
        :class="[
            'card with-linkclass',
            'card--' + data.style,
            'card--' + data.layout,
            data.linkclass,
            data.orientation,
            (data.link && !disableLink) ? null : 'no-hover'
        ]"
    >
         
        <div v-if="data.image.url" class="card-image">
            <div v-if="data.allowFavourites && location!=='viewsContentLanding'">
                <div @mouseover.self="tooltipinfoHoverIn($event, 'Add to Moodboard')" @mouseleave.self="tooltipinfoHoverOut($event)" ref="addFav" class="fav add-fav" :data_id="data.image.id" :class="data.isFavorite" @click="addFav(data.image.id)" data-category="MoodBoard" data-action="Click" data-label="Heart"></div>
                <div @mouseover.self="tooltipinfoHoverIn($event, 'Remove from Moodboard')" @mouseleave.self="tooltipinfoHoverOut($event)" ref="removeFav" class="fav remove-fav" :class="data.isFavorite " @click="removeFav(data.image.id)" data-category="MoodBoard" data-action="Click" data-label="Heart"></div>
            </div>

            <div class="pin-button__wrap" v-if="allowPin">
                <PinButton
                    :imageURL="data.image.url"
                    :imageDescription="data.title"
                ></PinButton>
            </div> 

            <div v-if="data.image">
                <a v-if="data.link && !disableLink" :href="data.link" :title="data.title" :aria-label="data.title" :target="data.linkTarget" class="card-image-link"></a>
                
                <div class="image-item-wrapper">
                    <image-item
                        class="image-item"
                        v-if="data.image"
                        :source="data.image.url"
                        :moodUrl="data.image.moodUrl"
                        :alt="data.title"
                        :position="data.position"
                        :imageClass="imageClass"
                        :imageHeight="data.image.size ? data.image.size.height : ''"
                        :imageWidth="data.image.size ? data.image.size.width : ''"
                    >
                    </image-item>
                </div>
            </div>
        </div>
        <div>
            <span v-if="data.tag" class="tag">{{data.tag}}</span>

            <a v-if="data.link && !disableLink" :href="data.link" :title="data.title" :aria-label="data.title" :target="data.linkTarget">
                <h4 class="medium">{{data.title}}</h4>
            </a>
            <h4 v-else class="medium">{{data.title}}</h4>

            <p v-if="data.description" v-html="data.description"></p>
            <div v-if="data.content" v-html="data.content"></div>

            <div class="info--wrap info--wrap--1">
                <div v-for="solutionSet in data.solutionSets" :key="solutionSet.id" class="info row">
                    
                    <div  v-if="solutionSet.data.solution.exists"  class="info-item info-icon info-icon--category col">
                        <img :src="solutionSet.data.solution.icon" alt="">
                    </div>
                    
                    <div v-if="solutionSet.data.profile.exists" class="info-item info-icon info-icon--category col">
                        <img :src="solutionSet.data.profile.icon" alt="">
                    </div>
                    
                    <div class="info-item col">
                        <colour-card :data="solutionSet.data.colour" :theme="theme" :location="location"/>
                    </div>
                </div>
            </div>

            <div v-if="data.pdf || data.sample === true" class="download">
                <a v-if="data.pdf" :href="data.pdf" :aria-label="data.title" :title="data.title" class="button button--solid-black" target="_blank" download>Download</a>
                <a v-if="data.sample === true" href="/" :aria-label="data.title" :title="data.title" class="button button--clear-black">Request a copy</a>
            </div>
            
            <div v-if="data.showLinksAsButtons" class="cta-wrapper">
                <a v-if="data.link" :href="data.link" class="button button--solid-black" :target="data.linkTarget">{{data.linkLabel}}</a>
                <a v-if="data.secondarylink"  :href="data.secondarylink" class="button button--clear-black" :target="data.secondarylinkTarget">{{data.secondarylinkLabel}}</a>
            </div>

        </div>

    </div>

    <div v-else 
        :class="[
            'card no-linkclass',
            'card--' + data.style,
            'card--' + data.layout,
            'location--'  + location,
            data.linkclass,
            data.orientation,
            (data.link) ? null : 'no-hover'
        ]"
    >
        <div v-if="data.image.url" class="card-image">
            <div v-if="data.allowFavourites && location!=='viewsContentLanding'">
                <div @mouseover.self="tooltipinfoHoverIn($event, 'Add to Moodboard')" @mouseleave.self="tooltipinfoHoverOut($event)" ref="addFav" class="fav add-fav" :data_id="data.image.id" :class="data.isFavorite" @click="addFav(data.image.id)"></div>
                <div @mouseover.self="tooltipinfoHoverIn($event, 'Remove from Moodboard')" @mouseleave.self="tooltipinfoHoverOut($event)" ref="removeFav" class="fav remove-fav" :class="data.isFavorite " @click="removeFav(data.image.id)"></div>
            </div>

            <div class="pin-button__wrap" v-if="allowPin">
                <PinButton
                    :imageURL="data.image.url"
                    :imageDescription="data.title"
                ></PinButton>
            </div> 

            <div v-if="data.image" :title="data.title" :aria-label="data.title">
                <a v-if="data.link" :href="data.link" :title="data.title" :aria-label="data.title" class="card-image-link" :target="data.linkTarget"></a>

                <div class="image-item-wrapper">
                    <image-item
                        class="image-item"
                        v-if="data.image"
                        :source="data.image.url"
                        :moodUrl="data.image.moodUrl"
                        :alt="data.title"
                        :position="data.position"
                        :imageClass="imageClass"
                        :imageHeight="data.image.size ? data.image.size.height : 0"
                        :imageWidth="data.image.size ? data.image.size.width : 0"
                    >
                    </image-item>
                </div>
            </div>
        </div>
        <div>
            <span v-if="data.tag" class="tag">{{data.tag}}</span>
            <a v-if="data.link" :href="data.link" :title="data.title" :aria-label="data.title" :target="data.linkTarget">
                <h4 class="medium">{{data.title}}</h4>
                
            </a>
            <h4 v-else class="medium">{{data.title}}</h4>
            <p v-if="data.description" v-html="data.description"></p>
            <div v-if="data.content" v-html="data.content"></div>
            <div class="info--wrap info--wrap--2">

                <div v-for="solutionSet in data.solutionSets" :key="solutionSet.id" class="info row">

                    <div v-if="solutionSet.data.solution.exists"  class="info-item info--solution info-icon info-icon--category col">
                        <img class="solutionset-icon" :src="solutionSet.data.solution.icon" alt="">
                        <label class="solutionset-name" v-html="isLinebreakString(solutionSet.data.solution.name)"></label>
                    </div>
                    
                    <div v-if="solutionSet.data.profile.exists" class="info-item info--profile info-icon info-icon--category col">
                        <img class="solutionset-icon" :src="solutionSet.data.profile.icon" alt="">
                        <label class="solutionset-name">
                            <span v-if="solutionSet.data.profile.type">Profile:</span>
                            <span v-html="isLinebreakString(solutionSet.data.profile.name)"></span>
                        </label>
                    </div>

                    <div class="info-item info--colour col">
                        <colour-card :isTitleLinebreak="true" :data="solutionSet.data.colour" :theme="theme" :location="location"/>
                    </div>

                    <div v-if="solutionSet.data.usecase.exists" class="info-item info--usecase info-icon info-icon--category col">
                        <img class="solutionset-icon" :src="solutionSet.data.usecase.icon" alt="">
                        <label class="solutionset-name" v-html="isLinebreakString(solutionSet.data.usecase.name)"></label>
                    </div>

                    <div v-if="solutionSet.data.roofColour" class="info-item info--roof col">
                        <colour-card :isTitleLinebreak="true" :data="solutionSet.data.roofColour" :theme="theme" :location="location"/>
                    </div>

                    <div v-if="solutionSet.data.houseColour" class="info-item info--house col">
                        <colour-card :isTitleLinebreak="true" :data="solutionSet.data.houseColour" :theme="theme" :location="location"/>
                    </div>

                    <div v-if="solutionSet.data.trimColour" class="info-item info--trim col">
                        <colour-card :isTitleLinebreak="true" :data="solutionSet.data.trimColour" :theme="theme" :location="location"/>
                    </div>
                </div>
                
            </div>
            <div v-if="data.pdf || data.sample === true" class="download">
                <a v-if="data.pdf" :href="data.pdf" :aria-label="data.title" :title="data.title" class="button button--solid-black" target="_blank" download>Download</a>
                <a v-if="data.sample === true" href="/" :aria-label="data.title" :title="data.title" class="button button--clear-black">Request a copy</a>
            </div>
        </div>
    </div>

</template>

<script>
import axios from 'axios';
import ImageItem from "../Image/ImageItem";
import ColourCard from "../../components/Cards/ColourCard";
import PinButton from "../../components/PinButton/PinButton";

export default {
    name: "card",
    components: {
        ImageItem,
        ColourCard,
        PinButton,
        // Fragment
    },
    props: {
        data: {
            type: Object,
            required: true
        },
        theme: {
            type: String
        },
        location: {
            type: String
        },
        allowPin: {
            type: Boolean
        },
        imageClass: {
            type: String,
            required: false
        }
    },
    computed: {
        disableLink () {
            return (this.data.link && this.data.showLinksAsButtons || this.data.showLinksAsButtons && this.data.secondarylink);
        }
    },
    methods: {
        isLinebreakString (string) {
            let parts = string.split(" ");
            return parts.join('<br>');
        },

        addFav (id) {
            const e1 = this.$el.querySelector(".add-fav").classList;
            const e2 = this.$el.querySelector(".remove-fav").classList;

            e2.add('d-block');
            e2.add('opacity-none');
            setTimeout(() => {
                e2.add('opacity-one');
                e2.remove('opacity-none');
            }, 25);
            setTimeout(() => {
                e1.add('selected');
                e2.add('selected');

                e2.remove('d-block');
                e2.remove('opacity-one');
            }, 275);

            axios.get(`/moodboardapi/item/${id}/toggle/?${Date.now()}`)
                .then(response => {
                    const message = {
                        title: 'Item added to moodboard',
                        text: '<a href="/inspiration/mood-board/">Item added to moodboard</a>',
                    }
                    
                    this.appendtoNotification(message);
                    this.toggleNotificationMoodboard();
                })
                .catch(error => {
                    console.log(error);
                })
            
            this.$emit('toggleFav', {
                id: this.data.id || 0,
                action: 'added',
            });
        },

        removeFav (id) {
            const e1 = this.$el.querySelector(".add-fav").classList;
            const e2 = this.$el.querySelector(".remove-fav").classList;

            var classStr = e2.value;
            var hasRemove = classStr.includes("fav remove-fav selected remove");
            
            if (hasRemove) {
                this.$el.classList.add('fade-out');    
            }

            e1.remove('selected');
            e2.add('d-block');
            e2.add('opacity-one');
            setTimeout(() => {
                e2.add('opacity-none');
                e2.remove('opacity-one');
            }, 25);
            setTimeout(() => {
                e2.remove('selected');
                e2.remove('opacity-one');
                e2.remove('d-block');
            }, 275);

            axios.get(`/moodboardapi/item/${id}/toggle/?${Date.now()}`)
                .then(response => {
                    const message = {
                        title: 'Item removed from moodboard',
                        text: '<a href="/inspiration/mood-board/">Item removed from moodboard</a>',
                    };

                    this.appendtoNotification(message);
                    this.toggleNotificationMoodboard();
                })
                .catch(error => {
                    console.log(error);
                })

            this.$emit('toggleFav', {
                id: this.data.id || 0,
                action: 'removed'
            });
        }
    }
};
</script>

<style lang="scss" scoped>

@import "../../../scss/abstracts/variables";

.pin-button__wrap {
    position: absolute;
    right: 0;
    z-index: 9;
    transition: all 300ms;

    @media (min-width: 768px) {
        opacity: 0;
    }
}

.card-image:hover {
    .pin-button__wrap {
        opacity: 1;
    }
    .fav {
        opacity: 1;
    }
}

.info--wrap {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;

    .info {
       
        .info-item {
            &:empty{

                display: inline-block;
                margin-bottom: 2rem;
                min-height: 50px;
                margin-right: 0;
                width: 0px;
                

                
            }
            img {
                max-width: 100%;
            }
        }
    }
    
}
.colour-card:v-deep(.colour-circle) {
    margin : 0;
}

.colour-card:deep(.info) {
    display: none;
}

.card-image{
    
    .card-image-link{
            position: absolute;
            display: block;
            height: 100%;
            width: 100%;
            top: 0;
            z-index: 6;
    }

}

</style>

